module.exports = __webpack_public_path__ + "static/media/guinsoolab-platform-overview.ff572050.png";